var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretUpSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05985 0.937683C8.47391 0.351746 7.52235 0.351746 6.93641 0.937683L0.93641 6.93768C0.50516 7.36893 0.378597 8.01112 0.612972 8.57362C0.847347 9.13612 1.3911 9.50175 2.00047 9.50175H14.0005C14.6052 9.50175 15.1536 9.13612 15.388 8.57362C15.6223 8.01112 15.4911 7.36893 15.0645 6.93768L9.06453 0.937683H9.05985Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUpSolid);
export default __webpack_public_path__ + "static/media/caret-up-solid.9e93cb9845ed1adf866e1c0be94db0e6.svg";
export { ForwardRef as ReactComponent };